import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for L402 (文件查詢)
// ============================================================

export interface DocumentItem {
  fl020_01: string; // 文件編號
  fl020_11: string; // 文件名稱
  fl020_12: string; // 文件類別代碼
  fl020_13: string; // 版本
  fl020_14: string; // 建立日期 (YYYY-MM-DD)
  fl020_15: string; // 建立人員
}

export interface QueryResponse {
  items: DocumentItem[];
  total: number;
}

export interface SectionItem {
  fl120_01: string; // 文件編號 FK
  fl120_02: number; // 章節序號
  fl120_11: string; // 章節名稱
  fl120_12: string; // 章節內容摘要
  fl120_13: string; // 附件路徑
}

export interface SectionsResponse {
  items: SectionItem[];
  total: number;
}

// ============================================================
// API methods
// ============================================================

export const l402Api = {
  /** Query document records with optional filters */
  async queryDocuments(params: {
    category?: string;
    keyword?: string;
  }): Promise<QueryResponse> {
    const p: Record<string, string> = {};
    if (params.category?.trim()) p['category'] = params.category.trim();
    if (params.keyword?.trim())  p['keyword']  = params.keyword.trim();
    const res = await apiClient.get('/api/l402/documents', { params: p });
    return res.data;
  },

  /** Get sections for a specific document */
  async querySections(docId: string): Promise<SectionsResponse> {
    const res = await apiClient.get(`/api/l402/documents/${encodeURIComponent(docId)}/sections`);
    return res.data;
  },
};
